import apiClient from "./apiClient";

export const dashboardService = {
  // Everything the dashboard shows, in one call (employee from the token).
  // Any section except actionItems can be null when it failed to load.
  getMine: () => apiClient.get("/dashboard/me"),
};
